var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-title"},[_c('div',{staticClass:"bg-left"}),_c('div',{staticClass:"bg-elem"},[_vm._t("default")],2),_c('div',{staticClass:"bg-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }